import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputDatepickerNewComponent } from '../../components/input-datepicker-new/input-datepicker-new.component';
import { TableUsageStatisticsComponent } from '../../components/table-usage-statistics/table-usage-statistics.component';
import { TableHrInvitationsComponent } from '../../components/table-hr-invitations/table-hr-invitations.component';
import { TableUtilizationInPeriodComponent } from '../../components/table-utilization-in-period/table-utilization-in-period.component';
import { TableServicesUsedComponent } from '../../components/table-services-used/table-services-used.component';
import { RoiCalculatorInfoPopoverComponent } from '../../components/roi-calculator-info-popover/roi-calculator-info-popover.component';
import { ItemRatingComponent } from '../../components/item-rating/item-rating.component';
import { NgGoogleChartsComponent } from '../../components/ng-google-charts/ng-google-charts.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import Config from '../../utils/config.service';
import RestService from '../../services/core-rest.service';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import RoutingService from '../../services/routing.service';
import RainbowColorService from '../../services/rainbow-color.service';
import moment from 'moment';
import { PanelDirective } from '../../directives/panel.directive';
import { HrComparisonPeriodInfoPopover } from "../../components/hr-comparison-period-info-popover/hr-comparison-period-info-popover.component";
import { MarkdownBoldPipe } from '../../filters/markdown-bold.pipe';
import { ROI_CONFIG } from './roi.config';

@Component({
	standalone: true,
	selector: 'hr-dashboard',
	templateUrl: './hr-dashboard.component.html',
	imports: [
		CommonModule, PanelDirective, TranslatePipe, LoaderOverlayComponent,
		InputDatepickerNewComponent, TableUsageStatisticsComponent, TableHrInvitationsComponent,
		TableUtilizationInPeriodComponent, TableServicesUsedComponent, RoiCalculatorInfoPopoverComponent,
		ItemRatingComponent, FormsModule, NgGoogleChartsComponent, HrComparisonPeriodInfoPopover, MarkdownBoldPipe
	]
})
export default class HrDashboardView implements OnInit, OnDestroy {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	private restService: RestService = inject(RestService);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private routingService: RoutingService = inject(RoutingService);
	private rainbowColorService: RainbowColorService = inject(RainbowColorService);

	vm: any = undefined;
	watchers: Array<any> = [];

	constructor() {
		this.vm = this;
	}

	ngOnInit() {
		this.routingService.validateAccess('dashboard').then(() => {
			this.onResolve();
		});
	}
	
	ngOnDestroy() {
		for (var i = 0; i < this.watchers.length; i++) {
			this.angularHelperService.cancelInterval(this.watchers[i]);
		}
	}

	onResolve() {
		this.vm.user = this.session.getSession().user;
		this.vm.origin = this.vm.user.origin;
		this.vm.language = this.vm.user.deviceLanguage;
		this.vm.isSiffi = this.vm.origin == 'siffi.com';
		this.vm.isMinuDoc = this.vm.origin == 'minudoc.ee';
		this.vm.generatedPreview = null;
		this.vm.loading = true;
		this.vm.conditionForBarChart = true;
		this.vm.conditionForPieChart = true;
		this.vm.isFullGraphOpened = false;
		this.vm.dateRangeMin = moment().subtract(12, 'months').toDate();
		this.vm.groups = [null];
		this.vm.groupItems = [null, 'empty'];
		this.vm.selectedGroup = null
		this.vm.selectedGroupItem = null;
		this.vm.additionalInfoGroups = [1, 2];
		this.vm.selectedAdditionalInfoGroup = 1;
		this.vm.dateRangeModel = {
			start: moment().subtract(3, 'months').toDate(),
			end: moment(new Date()).toDate()
		};
		
		var localStart = undefined;
		var localEnd = undefined;
		this.watchers.push(
			this.angularHelperService.createInterval(() => {
				if (!this.angularHelperService.equals(this.vm.dateRangeModel.start, localStart)
					|| !this.angularHelperService.equals(this.vm.dateRangeModel.end, localEnd)) {
					localStart = this.vm.dateRangeModel.start;
					localEnd = this.vm.dateRangeModel.end;
					this.vm.createdStart = moment(localStart).format('YYYYMMDD');
					this.vm.createdEnd = moment(localEnd).format('YYYYMMDD');
					this.vm.loading = true;
					this.getReportPreview();
				}
			}, 200)
		);
		
		this.vm.createdStart = moment().subtract(3, 'months').format('YYYYMMDD');
		this.vm.createdEnd = moment(new Date()).format('YYYYMMDD');
		this.vm.getFirstProgressBarStyle = this.getFirstProgressBarStyle;
		this.vm.getSecondProgressBarStyle = this.getSecondProgressBarStyle;
		this.vm.getThirdProgressBarStyle = this.getThirdProgressBarStyle;
		this.vm.getEmployeeProgressBarStyle = this.getEmployeeProgressBarStyle;
		this.vm.getGotHelpedPercentageStyle = this.getGotHelpedPercentageStyle;
		this.vm.getUsageIntensityTextStyle = this.getUsageIntensityTextStyle;
		this.vm.openFullGraph = this.openFullGraph;
		this.vm.openSlicedGraph = this.openSlicedGraph;
		this.vm.generateReport = this.generateReport;
		this.vm.showCalculationInfo = this.showCalculationInfo;
		this.vm.handleCloseButtonClick = this.handleCloseButtonClick;
		this.vm.selectGroup = this.selectGroup;
		this.vm.selectKeyword = this.selectKeyword;
        this.vm.getTranslationTextForPopover = this.getTranslationTextForPopover;
		this.vm.getMostCommonKeywordsGraph = (value) => {
			console.log(value);
			this.vm.mostCommonKeywordsGraph = value;
		};
		this.vm.getDistributionOfUsageGraph = (value) => {
			this.vm.distributionOfUsageGraph = value;
		};
		this.getReportPreview();
		
		var averageCost = undefined;
		var monthlyPayment = undefined;
		var annualRevenue = undefined;
		var employeesNumber = undefined;
		this.watchers.push(
			this.angularHelperService.createInterval(() => {
				if (averageCost !== this.vm.averageCost) {
					averageCost = this.vm.averageCost;
					this.calculateSavingsInPeriod();
				}
				
				if (monthlyPayment !== this.vm.monthlyPayment) {
					monthlyPayment = this.vm.monthlyPayment;
					this.calculateSavingsInPeriod();
				}
				
				if (annualRevenue !== this.vm.annualRevenue) {
					annualRevenue = this.vm.annualRevenue;
					this.calculateSavingsInPeriod();
				}
				
				if (employeesNumber !== this.vm.employeesNumber) {
					employeesNumber = this.vm.employeesNumber;
					this.calculateSavingsInPeriod();
				}
			}, 500)
		);

	}

	getKeywordStatistics() {
		this.vm.loading = true;

		var params = {
			userId: this.vm.user.id,
			startDate: this.vm.createdStart,
			endDate: this.vm.createdEnd,
			language: this.vm.language
		};

		if (this.vm.selectedGroup && this.vm.selectedGroup !== 'null')
			params['groupId'] = this.vm.selectedGroup;

		if (this.vm.selectedGroupItem && this.vm.selectedGroupItem !== 'null')
			params['additionalInfo'] = this.vm.selectedGroupItem;

		this.restService.getKeywordStatistics(params)
			.then((data: any) => {
				this.vm.loading = false;
				this.vm.generatedPreview.issues = data.issues;
				this.vm.generatedPreview.issuesTranslations = data.issuesTranslations;
				this.vm.generatedPreview.previousPeriodIssues = data.previousPeriodIssues;
				this.initialize();
			})
			.catch((err) => {
				this.vm.loading = false;
				console.error(err);
			});
	}

	getReportPreview() {
		this.vm.loading = true;
		this.vm.aiRecommendations = false;

		var params = {
			userId: this.vm.user.id,
			startDate: this.vm.createdStart,
			endDate: this.vm.createdEnd,
			language: this.vm.language
		};

		if (this.vm.selectedGroup && this.vm.selectedGroup !== 'null')
			params['groupId'] = this.vm.selectedGroup;

		if (this.vm.selectedGroupItem && this.vm.selectedGroupItem !== 'null')
			params['additionalInfo'] = this.vm.selectedGroupItem;

		this.restService.getCustomerReport(params)
			.then((data: any) => {
				this.vm.loading = false;
				this.vm.generatedPreview = data;
				this.getSupportedGroups();
			})
			.catch((err) => {
				this.vm.loading = false;
				console.error(err);
			});
	}
	
	getReportPreviewAiRecommendations() {
		this.vm.aiRecommendationsLoading = true;
		this.vm.aiRecommendations = false;

		var params = {
			userId: this.vm.user.id,
			startDate: this.vm.createdStart,
			endDate: this.vm.createdEnd,
			language: this.vm.language
		};

		if (this.vm.selectedGroup && this.vm.selectedGroup !== 'null')
			params['groupId'] = this.vm.selectedGroup;

		if (this.vm.selectedGroupItem && this.vm.selectedGroupItem !== 'null')
			params['additionalInfo'] = this.vm.selectedGroupItem;

		this.restService.getCustomerReportAiRecommendations(params)
			.then((data: any) => {
				this.vm.aiRecommendationsLoading = false;
				this.vm.aiRecommendations = data.aiRecommendations;
			})
			.catch((err) => {
				this.vm.aiRecommendationsLoading = false;
				console.error(err);
			});
	}

	getSupportedGroups() {
		this.vm.loading = true;

		var params = {
			userId: this.vm.user.id,
			language: this.vm.language
		};

		this.restService.getSupportedGroups(params)
			.then((data: any) => {
				this.vm.loading = false;
				this.vm.groups = [null, ...data];
				this.initialize();
			})
			.catch((err) => {
				this.vm.loading = false;
				console.error(err);
			});
	}

	getReportPDF() {
		var userId: any = this.vm.user.id;
		var startDate: any = this.vm.createdStart;
		var endDate: any = this.vm.createdEnd;
		var url: any = this.config.getRestUrl() + 'rest/report/' + userId + '/report.pdf?startDate=' + startDate + '&endDate=' + endDate;

		var data: any = {
			recommendations: '',
			customerLogo: '',
			graphImage: this.vm.mostCommonKeywordsGraph,
			challengesGraphImage: null,
			usageGaugeImage: null,
			usagePieChartImage: this.vm.distributionOfUsageGraph,
			isChangePercentageColumnHidden: false,
			isIssuesChartShown: this.vm.conditionForBarChart,
			isChallengesChartShown: false,
			isUsageGaugeShown: true,
			isUsagePieChartShown: this.vm.conditionForPieChart
		};
		var reqOptions: any = {
			withCredentials: true,
			responseType: 'arraybuffer'
		};

		return this.httpClient.post(url, data, reqOptions);
	}

	initialize() {
		this.vm.dateRangeMin = this.vm.generatedPreview?.invitationDate
			? moment(this.vm.generatedPreview.invitationDate).toDate()
			: this.vm.dateRangeMin;
		this.vm.hAxisTitle = this.angularFilterHelperService.translate('Hr_Dashboard.Haxis_Title');
		this.vm.vAxisTitle = this.angularFilterHelperService.translate('Hr_Dashboard.Vaxis_Title');
		this.vm.hasIssuesToShow = (this.vm.generatedPreview?.issues || []).filter((item) => {
			return (item.tagsCount || 0) > 0
		}).length > 0;
		this.vm.highIntensity = this.angularFilterHelperService.translate('Hr_Dashboard.High_Intensity');
		this.vm.lowIntensity = this.angularFilterHelperService.translate('Hr_Dashboard.Low_Intensity');
		this.vm.normalIntensity = this.angularFilterHelperService.translate('Hr_Dashboard.Normal_Intensity');
		this.vm.titleH = this.angularFilterHelperService.translate('Hr_Dashboard.This_Report_Period');
		this.vm.titleV = this.angularFilterHelperService.translate('Hr_Dashboard.Previous_Report_Period');
		this.vm.titleHIfNotPreviousPeriodIssues = this.angularFilterHelperService.translate('Hr_Dashboard.Times_Used_In_Chat');
		this.vm.titleVIfNotPreviousPeriodIssues = this.angularFilterHelperService.translate('Hr_Dashboard.Wordcloud_Words');
		this.vm.conditionForBarChart = (this.vm.generatedPreview?.usersWhoUsedInPeriodCount || 0) >= 5
			&& this.vm.hasIssuesToShow;
		this.vm.conditionForPieChart = (this.vm.generatedPreview?.usersWhoUsedInPeriodCount || 0) >= 5
			&& (this.vm.generatedPreview?.groupUsageStatistics || []).length >= 1;

		var usagePercentage: any = this.vm.generatedPreview?.usagePercentage || 0;
		var normalUsagePercentageStart: any = this.vm.generatedPreview?.normalUsagePercentageStart || 0;
		if (usagePercentage < normalUsagePercentageStart) {
			this.vm.intensity = this.vm.lowIntensity;
			this.vm.isLowIntensityFlag = true;
		} else if (usagePercentage >= normalUsagePercentageStart
			&& usagePercentage <= normalUsagePercentageStart) {
			this.vm.intensity = this.vm.normalIntensity;
		} else if (usagePercentage > normalUsagePercentageStart) {
			this.vm.intensity = this.vm.highIntensity;
		}

		if (this.vm.generatedPreview) {
			this.buildGraph(false,
				this.vm.generatedPreview.issues || [],
				this.vm.generatedPreview.issuesTranslations || [],
				this.vm.generatedPreview.previousPeriodIssues || [],
				this.vm.generatedPreview.previousPeriodIssues
					? this.vm.titleV
					: this.vm.titleHIfNotPreviousPeriodIssues,
				this.vm.generatedPreview.previousPeriodIssues
					? this.vm.titleH : this.vm.titleVIfNotPreviousPeriodIssues,
				'Tags percent for the term'
			);
			this.buildPieChart(this.vm.generatedPreview.groupUsageStatistics || []);
		}
		this.vm.usersWhoUsedTwiceInPeriodPercentage = this.vm.generatedPreview?.usersWhoUsedTwiceInPeriodCount
			? this.getPercent(this.vm.generatedPreview?.usersWhoUsedTwiceInPeriodCount,
				this.vm.generatedPreview?.usersWhoUsedInPeriodCount) || 0 : 0;
		var totalBookingsHelped: any = this.vm.generatedPreview ? this.vm.generatedPreview.totalBookingsHelpedInPeriod || 0 : 0;
		var totalBookingsNotHelped: any = this.vm.generatedPreview ? this.vm.generatedPreview.totalBookingsNotHelpedInPeriod || 0 : 0;
		this.vm.totalBookingsVoted = totalBookingsHelped + totalBookingsNotHelped;
		this.vm.totalBookingsHelpedInPeriodPercentage = this.vm.totalBookingsVoted > 0
			? this.getPercent(totalBookingsHelped, this.vm.totalBookingsVoted)
			: 0;
		this.vm.disclaimer = this.angularFilterHelperService.translate('Hr_Dashboard.Intensity_Disclaimer')
			.replace('%s', this.vm.generatedPreview?.activeUserPercentage ? this.vm.generatedPreview.activeUserPercentage + '%' : 0 + '%');
		this.vm.userIntensity = this.angularFilterHelperService.translate('Hr_Dashboard.User_Intensity')
			.replace('%s', this.vm.intensity ? this.vm.intensity : 'n/a');
		this.vm.hasProblemsToShow = (this.vm.generatedPreview?.problemsForYearPeriod || []).length > 0;
		if (this.vm.hasProblemsToShow && this.vm.generatedPreview) {
			var problemsData: any = this.vm.generatedPreview.problemsForYearPeriod.map((problem) => {
				problem.translationText = this.getProblemGraphTranslationLabel(problem.translationText, this.vm.language);
				return problem;
			}).sort((a, b) => {
				var one: any = a.tagsCount || 0;
				var two: any = b.tagsCount || 0;
				return (one <= two ? (one === two ? 0 : 1) : -1);
			}).slice(0, 20);
			this.getPopularTags(problemsData || []);
		}

		this.vm.averageCost = 4000;
		this.vm.employeesNumber = (this.vm.generatedPreview?.activeUsersCount || 0) + (this.vm.generatedPreview?.pendingInvitationsCount || 0);
		this.vm.annualRevenue = this.vm.employeesNumber * 100000;
		console.log("Average cost: " + this.vm.averageCost);
		console.log("Employees number: " + this.vm.employeesNumber);
		console.log("Annual revenue: " + this.vm.annualRevenue);

		if (this.vm.employeesNumber < 10) {
			this.vm.payPerUsage = 30;
		} else if (this.vm.employeesNumber >= 10 && this.vm.employeesNumber < 50) {
			this.vm.payPerUsage = 15;
		} else if (this.vm.employeesNumber >= 50 && this.vm.employeesNumber < 100) {
			this.vm.payPerUsage = 20;
		} else if (this.vm.employeesNumber >= 100 && this.vm.employeesNumber < 500) {
			this.vm.payPerUsage = 10;
		} else {
			this.vm.payPerUsage = 5;
		}
		console.log("Pay per usage[payPerUsage]: " + this.vm.payPerUsage);

		if (this.vm.generatedPreview) {
			if (!!this.vm.generatedPreview.monthlySubscriptionFee) {
				this.vm.monthlyPayment = this.vm.generatedPreview.monthlySubscriptionFee;
				console.log("Monthly payment[monthlySubscriptionFee]: " + this.vm.monthlyPayment);
			} else if (!!this.vm.generatedPreview.monthlySubscriptionPerUser) {
				this.vm.monthlyPayment = this.vm.generatedPreview.monthlySubscriptionPerUser * this.vm.employeesNumber;
				console.log("Monthly payment[monthlySubscriptionPerUser * employeesNumber]: " + this.vm.monthlyPayment);
			} else {
				this.vm.monthlyPayment = this.vm.generatedPreview.activeUsersCount * this.vm.payPerUsage;
				console.log("Monthly payment[activeUsersCount * payPerUsage]: " + this.vm.monthlyPayment);
			}
			this.calculateSavingsInPeriod();
		}
	}

	calculateDaysExcludingWeekends(startPeriod, periodInDays) {
		var currentDay: any = startPeriod.clone();
		var weekends: any = 0;
		for (var i = 0; i < periodInDays; i++) {
			if (currentDay.day() === 0 || currentDay.day() === 6) {
				weekends++;
			}
			currentDay.add(1, 'day');
		}
		return periodInDays - weekends;
	}

	selectGroup(selectedGroup) {
		if (selectedGroup !== null && selectedGroup !== 'null') {
			var params = {
				userId: this.vm.user.id,
				groupId: this.vm.selectedGroup
			};

			this.restService.getGroupItems(params)
				.then((data: any) => {
					this.vm.groupItems = [null, 'empty', ...data];
					this.vm.selectedGroupItem = null;

					this.getKeywordStatistics();
				})
				.catch((err) => {
					console.error(err);
				});
		} else if (selectedGroup === null || selectedGroup === 'null' ) {
			this.vm.selectedGroup = null;
			this.vm.selectedGroupItem = null;
			this.vm.groupItems = [null, 'empty'];

			this.getKeywordStatistics();
		} else if (selectedGroup === '0') {
			this.vm.selectedGroup = '0';
			this.vm.selectedGroupItem = null;
			this.vm.groupItems = [null, 'empty'];

			this.getKeywordStatistics();
		}
	}

	selectKeyword(value) {
		if (value === null || value === 'null') {
			this.vm.selectedGroupItem = null;
		}
		this.vm.selectedGroupItem = value;
		this.getKeywordStatistics();
	}

	getTranslationTextForPopover() {
		return this.angularFilterHelperService.translate('Hr_Dashboard.Comparison_Period');
	}

	calculateSavingsInPeriod(): void {
		const C = ROI_CONFIG;

		const startPeriod = moment(this.vm.createdStart);
		const endPeriod = moment(this.vm.createdEnd);
		const periodInDays = endPeriod.diff(startPeriod, 'days') + 1;
		const periodInDaysWithoutWeekends = this.calculateDaysExcludingWeekends(startPeriod, periodInDays);
		const periodFraction = periodInDaysWithoutWeekends / C.WORKING_DAYS_IN_YEAR;

		/* ── Three population tiers from platform data ───────── */
		const totalHeadcount = this.vm.employeesNumber || 1;
		const activatedUsers = this.vm.generatedPreview.activeUsersCount || 1;
		const usedServicesInPeriod = this.vm.generatedPreview.usersWhoUsedInPeriodCount || 1;

		/* ── Derived economic values ─────────────────────────── */
		const dailyBusinessValue = this.vm.averageCost * C.PRODUCTIVITY_MULTIPLIER / C.WORK_DAYS_PER_MONTH;
		const richmondFactor = 1 - C.RICHMOND_CONFOUNDER;

		/* ── A) Presenteeism ─────────────────────────────────── */
		const presPreDaysPerUser   = C.PRESENTEEISM_90D * 90;
		const presSavedDaysPerUser = presPreDaysPerUser * C.PRESENTEEISM_REDUCTION * richmondFactor;
		const presenteeismDaysSaved = usedServicesInPeriod * presSavedDaysPerUser;
		const presenteeismValue = presenteeismDaysSaved * dailyBusinessValue * periodFraction;


		/* ── B) Absenteeism ──────────────────────────────────── */
		const absSavedDaysPerUser  = C.ABSENTEEISM_DAYS_90D * C.ABSENTEEISM_REDUCTION * richmondFactor;
		const absenteeismDaysSaved = usedServicesInPeriod * absSavedDaysPerUser;
		const absenteeismValue = absenteeismDaysSaved * dailyBusinessValue * periodFraction;

		/* ── C) Turnover  (pool: actual service users) */
		const replacementCost      = this.vm.averageCost * C.TURNOVER_COST_MULTIPLIER;
		const turnoverPrePerUser   = C.TURNOVER_RATE_AT_RISK * replacementCost;
		const turnoverSavedPerUser = turnoverPrePerUser * C.TURNOVER_REDUCTION * richmondFactor;
		const turnoverValue = usedServicesInPeriod * turnoverSavedPerUser * periodFraction;

		/* ── Siffi cost ────────────── */
		const annualSiffiCost = 12 * (C.BASE_COUNSELLING_RATE * totalHeadcount * C.BASE_COUNSELLING_PRICE + C.PREMIUM_RATE * totalHeadcount * C.PREMIUM_PRICE);
		const siffiCostInPeriod = annualSiffiCost * periodFraction;

		/* ── Totals & ROI ───────────────────────────────────── */
		const totalSavings = presenteeismValue + absenteeismValue + turnoverValue;
		const netBenefit = totalSavings - siffiCostInPeriod;

		/* ── Write results to view model ─────────────────────── */
		this.vm.approximateSavings = Math.round(totalSavings);
		this.vm.approximateNetBenefit = Math.round(netBenefit);
		this.vm.approximateReturnOnInvestment = siffiCostInPeriod > 0 ? Math.round((netBenefit / siffiCostInPeriod) * 100) / 100 : 0;
		this.vm.approximateROIPercent = siffiCostInPeriod > 0 ? Math.round((netBenefit / siffiCostInPeriod) * 100) : 0;

		this.vm.presenteeismValue = Math.round(presenteeismValue);
		this.vm.absenteeismValue = Math.round(absenteeismValue);
		this.vm.turnoverValue = Math.round(turnoverValue);

		this.vm.savingsPerEmployee = totalHeadcount > 0 ? Math.round(totalSavings / totalHeadcount) : 0;
		this.vm.costPerEmployee = totalHeadcount > 0 ? Math.round(siffiCostInPeriod / totalHeadcount) : 0;
		this.vm.netBenefitPerEmployee = totalHeadcount > 0 ? Math.round(netBenefit / totalHeadcount) : 0;
		this.vm.activationRate = totalHeadcount > 0 ? activatedUsers / totalHeadcount : 0;
		this.vm.usageRate = totalHeadcount > 0 ? usedServicesInPeriod / totalHeadcount : 0;
	}

	showCalculationInfo() {
		this.vm.isOpen = true;
	}
	handleCloseButtonClick() {
		this.vm.isOpen = false;
	}

	getColorsByCountOfValues(count, isMinudoc) {
		return this.rainbowColorService.getColorsByCountOfValues(count, isMinudoc);
	}

	getPercent(x, y) {
		return Math.round((x / y) * 100);
	}

	selectUsageByAdditionalInfoGroup(groupId) {
		if (groupId == 2) {
			this.buildPieChart(this.vm.generatedPreview.groupUsageStatistics2 || []);
		} else {
			this.buildPieChart(this.vm.generatedPreview.groupUsageStatistics || []);
		}
	}

	buildPieChart(groupUsages) {
		if (this.vm.conditionForPieChart) {
			this.vm.pieChartOptions = {
				chartType: 'PieChart',
				dataTable: [['Department', 'Count']].concat(
					groupUsages.map((item) => {
						return [item['name'], item['bookingCount']]
					})),
				options: {
					pieHole: 0.4,
					colors: this.getColorsByCountOfValues(groupUsages.length > 1 ? groupUsages.length : 2, this.vm.isMinuDoc),
					legend: {
						position: "right"
					},
					pieSliceText: "percentage",
					tooltip: { text: 'value-and-percentage' },
					pieSliceTextStyle: {
						'color': 'black'
					},
					chartArea: {
						height: "90%",
						width: "95%"
					}
				}
			}
		}
	}

	getFirstProgressBarStyle() {
		if (this.vm.isMinuDoc) {
			var styleMinudoc: any = "--primary: #004cdd; --secondary: #eaecf0; min-height: 55px; min-width: 100px; margin-top: 5px; ";
			styleMinudoc += ('--value: ' + this.vm.firstTagPercent + ';');
			return styleMinudoc;
		} else if (this.vm.isSiffi) {
			var styleSiffi: any = "--primary: #287638; --secondary: #eaecf0; min-height: 55px; min-width: 100px; margin-top: 5px; ";
			styleSiffi += ('--value: ' + this.vm.firstTagPercent + ';');
			return styleSiffi;
		}
	}

	getSecondProgressBarStyle() {
		if (this.vm.isMinuDoc) {
			var styleMinudoc: any = "--primary: #004cdd; --secondary: #eaecf0; min-height: 55px; min-width: 100px; margin-top: 5px; ";
			styleMinudoc += ('--value: ' + this.vm.secondTagPercent + ';');
			return styleMinudoc;
		} else if (this.vm.isSiffi) {
			var styleSiffi: any = "--primary: #287638; --secondary: #eaecf0; min-height: 55px; min-width: 100px; margin-top: 5px; ";
			styleSiffi += ('--value: ' + this.vm.secondTagPercent + ';');
			return styleSiffi;
		}
	}

	getThirdProgressBarStyle() {
		if (this.vm.isMinuDoc) {
			var styleMinudoc: any = "--primary: #004cdd; --secondary: #eaecf0; min-height: 55px; min-width: 100px; margin-top: 5px; ";
			styleMinudoc += ('--value: ' + this.vm.thirdTagPercent + ';');
			return styleMinudoc;
		} else if (this.vm.isSiffi) {
			var styleSiffi: any = "--primary: #287638; --secondary: #eaecf0; min-height: 55px; min-width: 100px; margin-top: 5px; ";
			styleSiffi += ('--value: ' + this.vm.thirdTagPercent + ';');
			return styleSiffi;
		}
	}

	getEmployeeProgressBarStyle() {
		if (this.vm.isMinuDoc) {
			var styleMinudoc: any = "--primary: #004cdd; --secondary: #eaecf0; min-height: 55px; min-width: 100px; margin-top: 5px;";
			if (this.vm.generatedPreview) {
				styleMinudoc += ('--value: '
					+ this.vm.generatedPreview.usagePercentage + ';');
			}
			return styleMinudoc;
		} else if (this.vm.isSiffi) {
			var styleSiffi: any = "--primary: #287638; --secondary: #eaecf0; min-height: 55px; min-width: 100px; margin-top: 5px; ";
			if (this.vm.generatedPreview) {
				styleSiffi += ('--value: ' + this.vm.generatedPreview.usagePercentage
					+ ';');
			}
			return styleSiffi;
		}
	}

	getUsageIntensityTextStyle() {
		if (!!this.vm.isLowIntensityFlag) {
			return 'color: orange';
		}
		return 'color: green';
	}

	getGotHelpedPercentageStyle() {
		if (this.vm.generatedPreview) {
			if (this.vm.generatedPreview.totalBookingsHelpedInPeriod) {
				var styleHelped: any = "font-size: 25px; color: #118a2a; margin-top: 15px;";
				return styleHelped;
			} else if (!this.vm.generatedPreview.totalBookingsHelpedInPeriod) {
				if (this.vm.isMinuDoc) {
					var styleNotHelpedMinudoc: any = "font-size: 25px; color: #004cdd; margin-top: 5px;";
					return styleNotHelpedMinudoc;
				} else if (this.vm.isSiffi) {
					var styleNotHelpedSiffi: any = "font-size: 25px; color: #287638; margin-top: 5px;";
					return styleNotHelpedSiffi;
				}
			}
		}
	}

	openFullGraph() {
		this.buildGraph(true,
			this.vm.generatedPreview.issues || [],
			this.vm.generatedPreview.issuesTranslations || [],
			this.vm.generatedPreview.previousPeriodIssues || [],
			this.vm.generatedPreview.previousPeriodIssues
				? this.vm.titleV
				: this.vm.titleHIfNotPreviousPeriodIssues,
			this.vm.generatedPreview.previousPeriodIssues
				? this.vm.titleH : this.vm.titleVIfNotPreviousPeriodIssues,
			'Tags percent for the term'
		);
		this.vm.isFullGraphOpened = true;
	}

	openSlicedGraph() {
		this.buildGraph(false,
			this.vm.generatedPreview.issues || [],
			this.vm.generatedPreview.issuesTranslations || [],
			this.vm.generatedPreview.previousPeriodIssues || [],
			this.vm.generatedPreview.previousPeriodIssues
				? this.vm.titleV
				: this.vm.titleHIfNotPreviousPeriodIssues,
			this.vm.generatedPreview.previousPeriodIssues
				? this.vm.titleH : this.vm.titleVIfNotPreviousPeriodIssues,
			'Tags percent for the term'
		);
		this.vm.isFullGraphOpened = false;
	}

	sumElements(arr) {
		if (arr && arr.length > 0) {
			return arr.reduce((a, b) => {
				return a + b;
			})
		}
		return 0;
	}

	buildGraph(isOpenFullGraph, issues, issuesTranslations, previousPeriodIssues, titleH, titleV, description) {
		var translationIssues: any = issues.map((i) => {
			var temp: any = issuesTranslations.find((element) => {
				return element.id === i.id
			});
			if (temp.translationText) {
				i.translationText = temp.translationText;
			}
			return i;
		});
		var translationPreviousPeriodIssues: any = previousPeriodIssues.map((i) => {
			var temp: any = issuesTranslations.find((element) => {
				return element.id === i.id
			});
			if (temp.translationText) {
				i.translationText = temp.translationText;
			}
			return i;
		});
		if (previousPeriodIssues) {
			var rawDataToRender: any = {};
			translationIssues.forEach((issue) => {
				rawDataToRender[issue['translationText']] = {};
				rawDataToRender[issue['translationText']].thisPeriodTagsCount = issue['tagsCount']
					|| 0;
			});
			translationPreviousPeriodIssues.forEach((issue) => {
				rawDataToRender[issue['translationText']] = rawDataToRender[issue['translationText']]
					? rawDataToRender[issue['translationText']]
					: {};
				rawDataToRender[issue['translationText']].previousPeriodTagsCount = issue['tagsCount']
					|| 0;
			});
			var totalCountOfTags: any = this.sumElements(Object.keys(rawDataToRender).map((key) => {
				var item: any = rawDataToRender[key];
				return item.thisPeriodTagsCount;
			}));
			var totalCountOfPreviousTags: any = this.sumElements(Object.keys(rawDataToRender).map((key) => {
				var item: any = rawDataToRender[key];
				return item.previousPeriodTagsCount;
			}));
			var dataToRender: any = Object.keys(rawDataToRender)
				.map((key) => {
					var item: any = rawDataToRender[key];
					return [key, this.getPercent(item.previousPeriodTagsCount, totalCountOfPreviousTags),
						this.getPercent(item.thisPeriodTagsCount, totalCountOfTags)];
				})
				.sort((a, b) => {
					var one: any = Number(a[1]) + Number(a[2]);
					var two: any = Number(b[1]) + Number(b[2]);
					return (one <= two ? (one === two ? 0 : 1) : -1);
				});
			var dataForThisTagsPeriod: any = Object.keys(rawDataToRender)
				.map((key) => {
					var item: any = rawDataToRender[key];
					return [key, this.getPercent(item.thisPeriodTagsCount, totalCountOfTags)];
				})
				.sort((a, b) => {
					var one: any = a[1];
					var two: any = b[1];
					return (one <= two ? (one === two ? 0 : 1) : -1);
				});
			if (totalCountOfPreviousTags > 0) {
				if (isOpenFullGraph) {
					var dataForFullGraph: any = dataToRender;
					this.vm.barChartOptions = {
						chartType: 'BarChart',
						dataTable: [['', titleH, titleV],].concat(dataForFullGraph),
						options: {
							colors: ['#4e6a7c', '#203744'],
							lineWidth: 10,
							height: 600,
							fontSize: 10,
							chartArea: {
								height: "85%",
								width: "55%"
							},
							hAxis: {
								title: this.vm.hAxisTitle,
								minValue: 0,
								textStyle: {
									fontSize: 10,
								}
							},
							vAxis: {
								title: this.vm.vAxisTitle,
								textStyle: {
									fontSize: 10,
								},
							}
						}
					};
				} else {
					var dataForSlicedGraph: any = dataToRender.slice(0, 7);
					this.vm.barChartOptions = {
						chartType: 'BarChart',
						dataTable: [['', titleH, titleV],].concat(dataForSlicedGraph),
						options: {
							colors: ['#4e6a7c', '#203744'],
							lineWidth: 10,
							height: 200,
							fontSize: 10,
							chartArea: {
								height: "85%",
								width: "55%"
							},
							hAxis: {
								title: this.vm.hAxisTitle,
								minValue: 0,
								textStyle: {
									fontSize: 10,
								}
							},
							vAxis: {
								title: this.vm.vAxisTitle,
								textStyle: {
									fontSize: 10,
								},
							}
						}
					};
				}
			} else {
				if (isOpenFullGraph) {
					var dataForFullGraph: any = dataForThisTagsPeriod;
					this.vm.barChartOptions = {
						chartType: 'BarChart',
						dataTable: [['', titleV]].concat(dataForFullGraph),
						options: {
							colors: ['#4e6a7c'],
							lineWidth: 10,
							height: 600,
							fontSize: 10,
							chartArea: {
								height: "85%",
								width: "55%"
							},
							hAxis: {
								title: this.vm.hAxisTitle,
								minValue: 0,
								textStyle: {
									fontSize: 12,
								}
							},
							vAxis: {
								title: this.vm.vAxisTitle,
								textStyle: {
									fontSize: 12,
								},
							}
						}
					};
				} else {
					var dataForSlicedGraph: any = dataForThisTagsPeriod.slice(0, 7);
					this.vm.barChartOptions = {
						chartType: 'BarChart',
						dataTable: [['', titleV]].concat(dataForSlicedGraph),
						options: {
							colors: ['#4e6a7c'],
							lineWidth: 7,
							height: 200,
							fontSize: 10,
							chartArea: {
								height: "85%",
								width: "55%"
							},
							hAxis: {
								title: this.vm.hAxisTitle,
								minValue: 0,
								textStyle: {
									fontSize: 12,
								}
							},
							vAxis: {
								title: this.vm.vAxisTitle,
								textStyle: {
									fontSize: 12,
								},
							}
						}
					};
				}
			}

		} else {
			this.vm.barChartOptions = {
				chartType: 'BarChart',
				dataTable: [[titleV, description],].concat(
					translationIssues.map((issue) => {
						return [issue['translationText'], issue['tagsCount']]
					})),
				options: {
					colors: ['#4e6a7c'],
					lineWidth: 15,
					fontSize: 10,
					chartArea: {
						height: "80%",
						width: "65%"
					}
				}
			};
		}
	}

	getProblemGraphTranslationLabel(translationText, languageCode) {
		var translationMappings: any = {
			'Anxiety': {
				"en_GB": "Anxiety",
				"de_DE": "Angst",
				"fi_FI": "Ahdistus",
				"et_EE": "Ärevus",
				"ru_RU": "Тревога"
			},
			'Stress': {
				"en_GB": "Stress",
				"de_DE": "Stress",
				"fi_FI": "Stressi",
				"et_EE": "Stress",
				"ru_RU": "Стресс"
			},
			'Anger': {
				"en_GB": "Anger",
				"de_DE": "Wut",
				"fi_FI": "Suututtaa",
				"et_EE": "Viha",
				"ru_RU": "Злость"
			},
			'Loneliness': {
				"en_GB": "Loneliness",
				"de_DE": "Einsamkeit",
				"fi_FI": "Yksinäisyys",
				"et_EE": "Üksildustunne",
				"ru_RU": "Одиночество"
			},
			'Irritability': {
				"en_GB": "Irritability",
				"de_DE": "Reizbarkeit",
				"fi_FI": "Ärsyttävyys",
				"et_EE": "Ärrituvus",
				"ru_RU": "Раздражительность"
			},
			'Motivation': {
				"en_GB": "Motivational problems",
				"de_DE": "Motivationsprobleme",
				"fi_FI": "Motivaatio-ongelmat",
				"et_EE": "Motivatsiooniprobleemid",
				"ru_RU": "Мотивационные проблемы"
			},
			'Burnout': {
				"en_GB": "Burnout",
				"de_DE": "Ausbrennen",
				"fi_FI": "Loppuun palaminen",
				"et_EE": "Läbipõlemine",
				"ru_RU": "Выгорание"
			},
			'Cognition': {
				"en_GB": "Cognitive problems",
				"de_DE": "Kognitive Probleme",
				"fi_FI": "Kognitiiviset ongelmat",
				"et_EE": "Kognitiivsed probleemid",
				"ru_RU": "Когнитивные проблемы"
			},
			'Crises': {
				"en_GB": "Psychological crises",
				"de_DE": "Psychische Krisen",
				"fi_FI": "Psykologinen kriisi",
				"et_EE": "Psühholoogilised kriisid",
				"ru_RU": "Психологические кризисы"
			},
			'Addiction': {
				"en_GB": "Addiction",
				"de_DE": "Sucht",
				"fi_FI": "Riippuvuus",
				"et_EE": "Sõltuvus",
				"ru_RU": "Зависимость"
			},
			'Sleep': {
				"en_GB": "Sleep problems",
				"de_DE": "Schlafstörung",
				"fi_FI": "Unihäiriöt",
				"et_EE": "Uneprobleemid",
				"ru_RU": "Проблемы со сном"
			},
			'Eating': {
				"en_GB": "Eating disorders",
				"de_DE": "Essstörungen",
				"fi_FI": "Syömishäiriöt",
				"et_EE": "Söömishäired",
				"ru_RU": "Расстройства пищевого поведения"
			},
			'Self-harm': {
				"en_GB": "Self-harm",
				"de_DE": "Selbstbeschädigung",
				"fi_FI": "Itsetuhoisuus",
				"et_EE": "Enesevigastamine",
				"ru_RU": "Членовредительство"
			},
			'Trauma': {
				"en_GB": "Trauma",
				"de_DE": "Trauma",
				"fi_FI": "Trauma",
				"et_EE": "Trauma",
				"ru_RU": "Травма"
			},
			'Suicidality': {
				"en_GB": "Suicidality",
				"de_DE": "Suizidalität",
				"fi_FI": "Itsemurha",
				"et_EE": "Suitsidaalsus",
				"ru_RU": "Суицидальность"
			},
			'Grief': {
				"en_GB": "Grief",
				"de_DE": "Kummer",
				"fi_FI": "Suru",
				"et_EE": "Lein",
				"ru_RU": "Горе"
			},
			'Family': {
				"en_GB": "Relationship problems",
				"de_DE": "Beziehungsprobleme",
				"fi_FI": "Suhde ja perheongelmat",
				"et_EE": "Suhte- ja pereprobleemid",
				"ru_RU": "Проблемы в отношениях/в семье"
			},
			'Mood': {
				"en_GB": "Mood problems",
				"de_DE": "Stimmungsprobleme",
				"fi_FI": "Mielialan ongelmat",
				"et_EE": "Meeleoluprobleemid",
				"ru_RU": "Проблемы с настроением"
			},
			'Work': {
				"en_GB": "Problems at work",
				"de_DE": "Probleme bei der Arbeit",
				"fi_FI": "Työssä olevat ongelmat",
				"et_EE": "Probleemid tööl",
				"ru_RU": "Проблемы на работе"
			},
			'LSE': {
				"en_GB": "Low self-esteem",
				"de_DE": "Geringe Selbstachtung",
				"fi_FI": "Alhainen itsetunto",
				"et_EE": "Madal enesehinnang",
				"ru_RU": "Низкая самооценка"
			},
			'Develop': {
				"en_GB": "Self-development",
				"de_DE": "Selbstentwicklung",
				"fi_FI": "Itsensä kehittäminen",
				"et_EE": "Eneseareng",
				"ru_RU": "Саморазвитие"
			},
			'Pain': {
				"en_GB": "Pain",
				"de_DE": "Schmerz",
				"fi_FI": "Kipu",
				"et_EE": "Valu",
				"ru_RU": "Боль"
			},
			'Other': {
				"en_GB": "Other",
				"de_DE": "Andere",
				"fi_FI": "Muut",
				"et_EE": "Muu",
				"ru_RU": "Другое"
			},
			'No_answer': {
				"en_GB": "Not defined",
				"de_DE": "Nicht definiert",
				"fi_FI": "Ei määritelty",
				"et_EE": "Ei ole defineeritud",
				"ru_RU": "Не определено"
			}
		};
		return translationMappings[translationText][languageCode];
	}

	getPopularTags(problems) {
		var rawDataToRender: any = {};
		problems.forEach((problem) => {
			rawDataToRender[problem['translationText']] = {};
			rawDataToRender[problem['translationText']].tagsCount = problem['tagsCount']
				|| 0;
		});

		var totalCountOfTags: any = this.sumElements(Object.keys(rawDataToRender)
			.map((key) => {
				var item: any = rawDataToRender[key];
				return item.tagsCount;
			}));
		var dataToRender: any = Object.keys(rawDataToRender)
			.map((key) => {
				var item: any = rawDataToRender[key];
				return [key, item.tagsCount];
			})
			.sort((a, b) => {
				var one: any = a[1] || 0;
				var two: any = b[1] || 0;
				return (one <= two ? (one === two ? 0 : 1) : -1);
			}).slice(0, 7);
		this.vm.firstPopularTag = dataToRender.map((key) => {
			return key.at(0);
		}).slice(0, 1).at(0);
		console.log("First: " + this.vm.firstPopularTag);
		this.vm.secondPopularTag = dataToRender.map((key) => {
			return key.at(0);
		}).slice(1, 2).at(0);
		this.vm.thirdPopularTag = dataToRender.map((key) => {
			return key.at(0);
		}).slice(2, 3).at(0);

		var firstPopularTagCount: any = dataToRender.map((key) => {
			return key.at(1);
		}).slice(0, 1).at(0);

		var secondPopularTagCount: any = dataToRender.map((key) => {
			return key.at(1);
		}).slice(1, 2).at(0);
		var thirdPopularTagCount: any = dataToRender.map((key) => {
			return key.at(1);
		}).slice(2, 3).at(0);

		this.vm.firstTagPercent = totalCountOfTags ? this.getPercent(
			firstPopularTagCount, totalCountOfTags) : 0;
		this.vm.secondTagPercent = totalCountOfTags ? this.getPercent(
			secondPopularTagCount, totalCountOfTags) : 0;
		this.vm.thirdTagPercent = totalCountOfTags ? this.getPercent(
			thirdPopularTagCount, totalCountOfTags) : 0;
	}

	generateReport() {
		this.vm.loading = true;
		this.getReportPDF().toPromise()
			.then((data: any) => {
				var blob: any = new Blob([data], { type: "application/pdf" });
				var objectUrl: any = URL.createObjectURL(blob);
				window.open(objectUrl);
				this.vm.loading = false;
			})
			.catch((data: any) => {
				console.log('Failed to download PDF');
				console.log(data);
				this.vm.loading = false;
			});
	};

}